import DataTableTitle from "../../DataTableComponents/DataTableTitle";

const AbsenPNSColumns = (absen) => {
  const findAbsen = (staf) => absen?.find((item) => item.id_user === staf.nama);

  return [
    {
      name: <DataTableTitle text={"Nama Staf"} />,
      selector: (row) => row.nama,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"NIP"} />,
      selector: (row) => row.nip,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Golongan PNS"} />,
      selector: (row) => row.golongan_pns,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Datang"} />,
      selector: (row) => row.datang?.jam ?? "",
      width: "15%",
      sortable: true,
    },
    {
      name: <DataTableTitle text={"TTD"} />,
      selector: (row) => "",
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Pulang"} />,
      selector: (row) => row.pulang?.jam ?? "",
      width: "15%",
      sortable: true,
    },
    {
      name: <DataTableTitle text={"TTD"} />,
      selector: (row) => "",
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Keterangan"} />,
      selector: (row) => findAbsen(row)?.keterangan,
      sortable: true,
      wrap: true,
    },
  ];
};

export default AbsenPNSColumns;
